export default {
  getLinks: (state) => state.links,
  getTemplates: (state) => state.templates,
};
